import { Collections } from '../../firebase/firestore/collections';
import { useDocumentSnapshot } from '../../firebase/firestore/hooks';
import { Seeker } from '../../firebase/firestore/documents/seeker';

export const useSingleSeeker = (seekerId: string | undefined): Seeker | undefined => {
  return useDocumentSnapshot<Readonly<Seeker>>(Collections.SEEKERS, seekerId);
};
